import { Component, Input } from '@angular/core';

import { NzSkeletonInputSize, NzSkeletonModule } from 'ng-zorro-antd/skeleton';

@Component({
  selector: 'ui-platform-file-upload-skeleton',
  templateUrl: './file-upload-skeleton.component.html',
  styleUrl: './file-upload-skeleton.component.less',
  imports: [NzSkeletonModule]
})
export class UiPlatformFileUploadSkeletonComponent {
  @Input() active = true;
  @Input() size: NzSkeletonInputSize = 'small';
}
